import { has } from "shared/utils";
import { Cell } from "./Cell";
import { ReportStatusBadge } from "./ReportStatusBadge";
import { Verification } from "../types";
import { useAuthContext } from "providers/Auth";

interface RentalApplicationCellProps {
  verification: Verification;
}

export const RentalApplicationCell = ({
  verification
}: RentalApplicationCellProps) => {
  const { permissions } = useAuthContext();
  return (
    <>
      <Cell
        isDataCell
        className="relative"
        showRestrictedFlag={!permissions.canAccessReports.rentalApplication}
        isPermitted={permissions.canAccessReports.rentalApplication}
      >
        {has(verification.summary?.total_dependents)
          ? verification.summary.total_dependents
          : "-"}
        <ReportStatusBadge verificationStatus={verification.status} />
      </Cell>
      <Cell
        isDataCell
        isPermitted={permissions.canAccessReports.rentalApplication}
      >
        {has(verification.summary?.total_vehicles)
          ? verification.summary.total_vehicles
          : "-"}
      </Cell>
      <Cell
        isDataCell
        isPermitted={permissions.canAccessReports.rentalApplication}
      >
        {has(verification.summary?.total_pets)
          ? verification.summary.total_pets
          : "-"}
      </Cell>
    </>
  );
};
